import { colorsVariables } from "../utils/types"

export const setFont = {
    title: "'Raleway', sans-serif;",
    body: "'Open Sans', sans-serif;",
}

export const zIndex = {
    negativeOne: "-1",
    zero: "0",
    one: "1",
    two: "2",
    three: "3",
    four: "4",
}

const size = {
    tablet: "768px",
    desktop: "1024px",
    desktopL: "1336px",
}

export const device = {
    tablet: `(min-width: ${size.tablet})`,
    desktop: `(min-width: ${size.desktop})`,
    desktopL: `(min-width: ${size.desktopL})`,
}

export const getColor = () => {
    const colors = process.env.REACT_APP_COLORS!.split(",")

    const variableColors:colorsVariables ={
        accent: colors[0],
        secondary: colors[1],
        background: colors[2],
        card: colors[3],
        chip: colors[4],
        textColor: colors[5],
        titleColor: colors[6],
        shadowColor: colors[7]
    }

    return variableColors

}

export const setRadius = {
    card: "8px",
    buttons: "12px",
    drawer: "12px",
}